import React from 'react'
import withLocalization from '@web/helpers/localizationUtils'
import { localization } from './localization'
import { useTheme } from '@web/contexts/ThemeProvider'
import themeStyles from '@web/containers/Appointments/components/UpcomingCard/styles'
import Link from 'next/link'

const JoinInButton = ({ zoomLink, t }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)

  return (
    <Link
      href={zoomLink}
      target={'_blank'}
      rel="noopener noreferrer"
      tabIndex={-1}
    >
      <button style={styles.joinInButton}>
        <span>{t('joinIn').toUpperCase()}</span>
      </button>
    </Link>
  )
}

export default withLocalization(JoinInButton, localization)
